module.exports = __webpack_public_path__ + "static/okta-92ebd8e180e52e0b3f6c4b9a3b10aace.svg";